import { E3Farm } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography, Box, Link, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { Trans } from 'react-i18next'
import useModals from 'src/Hooks/useModals'

/**
 * Retrofit not available content for systems
 */
const NoRetrofitWarning: React.FC = () => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  const { openInformationModal } = useModals()

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <E3Farm sx={{ width: 30, height: 30, mr: 2, color: 'primary.main' }} />
        <Typography variant={downMd ? 'h4' : 'h2'}>{t('retrofit-check.not-available.headline')}</Typography>
      </Box>
      <Typography sx={{ mb: 2 }} variant="body2">
        {t('retrofit-check.not-available.text')}
      </Typography>
      <Typography variant="body2">
        <Trans
          i18nKey={'retrofit-check.not-available.link.text'}
          components={{
            page: (
              <Link
                component={'button'}
                onClick={() =>
                  openInformationModal({
                    title: t('retrofit-check.not-available.suggestions.farming.details.title'),
                    textKey: 'retrofit-check.not-available.suggestions.farming.details.text',
                  })
                }
              />
            ),
            bold: <Typography component={'span'} variant="h5" />,
          }}
        />
      </Typography>
    </>
  )
}

export default NoRetrofitWarning
